import { RmaLgmTypeCodes } from '@harvestiq/constants';
import { z } from '@harvestiq/zod';

export const lgmMarketingMonthOffsetSchema = z.object({
  typeCode: z.nativeEnum(RmaLgmTypeCodes),
  salesEffectiveMonth: z.number(),
  offset: z.number(),
  lag: z.number(),
  averageFactor: z.number(),
  marketingMonth: z.string(),
  commodity: z.string(),
  cmeMonth: z.string(),
  cmeMonthNumber: z.number().nullable(),
  contractMonth: z.string(),
  contractMonthNumber: z.number(),
  yearDiff: z.number(),
});

export type LgmMarketingMonthOffset = z.infer<
  typeof lgmMarketingMonthOffsetSchema
>;
